import React, {
  Dispatch,
  SetStateAction,
  useEffect,
  useState,
  useContext,
} from "react";
import {
  MotifErrorMessage,
  MotifModal,
  MotifModalBody,
  MotifModalFooter,
  MotifModalHeader,
  MotifProgressLoader,
} from "@ey-xd/motif-react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import Button from "@/components/Form/Button/Button";
import { AddDebtorFormType } from "./type";
import "./FormModal.scss";

import { capitalizeWordsInSentence } from "@/utility/common";
import ControlSelect from "./SelectBox/editFieldSelectBox";
import { isNumeric } from "@/utility/validation";
import ControlInputBoxNumber from "@/components/Form/InputBox/ControlInputBoxNumber";
import ControlCheckBox from "@/components/Form/CheckBox/ControlCheckBox";
import {
  getDataSourceValue,
  getDistributionYear,
  postDataMappingSource,
  renderOptionList,
} from "../Form/calculationSummaryHelper";
import {
  useGetDataSourceSummaryEditApiDataQuery,
  useGetDistributionApiDataQuery,
  useGetListCalculationStepQuery,
  useGetManualDataSourceApiDataQuery,
  useUpdateStepDataSourceApiMutation,
} from "../calculationStepReducer";
import { useGetDistributionWithSameSequenceIdQuery } from "@/services/distribution/distributionReducers";
import ConfirmationModal from "@/components/Modal/ConfirmationModal/ConfirmationModal";
import {
  CANCEL_BUTTON_VARIANT,
  SAVE_BUTTON_VARIANT,
} from "@/components/Images/CommonImages";
import FutureReferencingLogic from "../Form/FutureReferencingLogic";
import { useParams } from "react-router-dom";
import { DistributionStepContext } from "../../summery/DistributionContext";
type Props = {
  isVisible: boolean;
  setIsVisible: React.Dispatch<React.SetStateAction<boolean>>;
  formData?: AddDebtorFormType | null;
  caseId: string;
  stepId: string;
  setIsRefetch: Dispatch<SetStateAction<boolean>>;
  setFormData: Dispatch<SetStateAction<AddDebtorFormType | null>>;
  editId: any;
  resolvedStatus: boolean;
};

export default function FormModal({
  isVisible,
  formData,
  setIsVisible,
  stepId,
  caseId,
  setIsRefetch,
  setFormData,
  editId,
  resolvedStatus,
}: Props) {
  const { t } = useTranslation();
  const [showMessage, setShowMessage] = useState({
    show: false,
    type: "error",
    message: "",
  });
  const [filteredDistributionList, setFilteredDistributionList] = useState([]);
  const [filteredDistributionListSeq, setFilteredDistributionListSeq] =
    useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isDistributionSeq, setIsDistributionSeq] = useState(false);
  const distributionStepContextData: any = useContext<any>(
    DistributionStepContext
  );
  let defaultOption = {
    label: t("global.globalActions.optionDefault"),
    value: "",
  };
  const [isFrenchSelected, setIsFrenchSelected] = useState(false);
  const [isVisibleCancel, setIsVisibleCancel] = useState(false);
  const { distributionId: currentDistributionId } = useParams<{
    distributionId: string;
  }>();

  const {
    handleSubmit,
    control,
    setValue,
    watch,
    getValues,
    reset,
    formState: { errors, isDirty },
  } = useForm<any>();
  useEffect(() => {
    if (formData !== null) {
      //@ts-ignore
      setValue("dataSource", getDataSourceValue(formData?.dataSource));
      //@ts-ignore
      setValue("weightingFactor", formData.weight);
      //@ts-ignore
      setValue(
        "filterApplicableClasses",
        // @ts-ignore
        formData?.applicableClasses === true ? true : false
      );
      //("filterApplicableClasses", formData.applicableClasses);
    } else {
      //@ts-ignore
      setValue("dataSource", "0");
      //@ts-ignore
      setValue("weightingFactor", "1");
      //@ts-ignore
      setValue("filterApplicableClasses", false);
    }
    reset(getValues());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData, setValue]);

  const errorList = Object.keys(errors);
  const errorsShow = capitalizeWordsInSentence(errorList.join(", "));
  let [updateStepDataSourceApi] = useUpdateStepDataSourceApiMutation();
  const onSubmit = async (data: any) => {
    setIsLoading(true);
    try {
      // @ts-ignore
      let postData = postDataMappingSource(data);
      let formDetails: any = formData || null;
      const responseApi: any = await updateStepDataSourceApi({
        ...postData,
        stepDataSourceId: formDetails?.stepDataSourceId,
        calculationStepId: stepId,
        caseId: caseId,
        sourceManualDataSourceId:
          data?.dataSource === "2" ? data?.manualDataSource : null,
        sourceCalculationStepId:
          data?.dataSource === "1" ? data?.calculationStep : null,
      });
      if (responseApi.hasOwnProperty("data")) {
        setIsRefetch(true);
        setIsVisible(false);
        setIsLoading(false);
        setFormData(null);
        setShowMessage({
          ...showMessage,
          show: false,
          type: "error",
          message: t(""),
        });
      } else {
        //@ts-ignore
        const error: any =
          responseApi.error?.data?.message ||
          t("global.globalNotifications.unExpectedError");
        setShowMessage({
          ...showMessage,
          show: true,
          type: "error",
          message: error,
        });
        setIsLoading(false);
      }
    } catch (error) {
      setShowMessage({
        ...showMessage,
        show: true,
        type: "error",
        message: t("global.globalNotifications.unExpectedError"),
      });
      setIsLoading(false);
    }
  };
  const getDataSource = watch("dataSource");
  const distributionId = watch("distribution");
  const entitleMentSet = watch("entitleMentSet");
  const { data: calculationStep, isFetching: stepCaluclationFetching } =
    useGetListCalculationStepQuery(
      {
        distributionId: distributionId,
        pageSize: 10000,
        SortColumn: "SortOrder",
      },
      { skip: !distributionId }
    );
  const {
    data: distributionWithSequence,
    isLoading: distributionWithSequenceLoading,
    isFetching: isDistributionSequenceFetching,
    status: distributionWithSequenceStatus,
  } = useGetDistributionWithSameSequenceIdQuery(currentDistributionId, {
    skip: !currentDistributionId,
  });
  const {
    data: distributionData,
    isLoading: isDistributionLoading,
    status: distributionListStatus,
  } = useGetDistributionApiDataQuery(caseId);

  let filterStepData = [];
  const calculationStepData = calculationStep?.results
    ? calculationStep.results
    : [];
  if (calculationStepData.length === 0) {
  } else if (distributionId !== currentDistributionId) {
    filterStepData = calculationStepData;
  } else {
    const index = calculationStepData.findIndex(
      (step: any) => step.id === stepId
    );
    filterStepData = calculationStepData.slice(0, index);
  }

  const calculationStepList = renderOptionList(
    filterStepData,
    "name",
    "id",
    defaultOption
  );
  const { data: manualDataSource, isLoading: isManualSourceLoading } =
    useGetManualDataSourceApiDataQuery(caseId);
  const { data: dataSourceById, isLoading: isViewApiLoading } =
    useGetDataSourceSummaryEditApiDataQuery(editId, {
      skip: !(
        ["fulfilled", "rejected"].includes(distributionWithSequenceStatus) &&
        ["fulfilled", "rejected"].includes(distributionListStatus)
      ),
    });
  const manualDataSourceList = renderOptionList(
    manualDataSource,
    "name",
    "id",
    defaultOption
  );

  const futureReferencingLogicValue = watch("futureReferencingLogic");
  const currentDistributionYear = getDistributionYear(
    distributionId,
    distributionData
  );
  const getFilterDistributionList = (distributionData: any) => {
    return distributionData?.results?.filter((item: any) => {
      if (futureReferencingLogicValue && futureReferencingLogicValue === "1") {
        const distributionYear = new Date(item.distributionDate).getFullYear();
        if (
          currentDistributionYear !== null &&
          distributionYear < currentDistributionYear
        ) {
          return true;
        } else {
          return false;
        }
      }
      return true;
    });
  };
  const distributionList = renderOptionList(
    filteredDistributionList,
    "name",
    "id",
    defaultOption
  );
  const currentDistributionYearSeq =
    distributionStepContextData.currentDistributionYear;
  const getFilterDistributionSeqList = (distributionWithSequence: any) => {
    return distributionWithSequence?.results?.filter((item: any) => {
      if (futureReferencingLogicValue && futureReferencingLogicValue === "1") {
        const distributionYear = new Date(item.distributionDate).getFullYear();
        if (
          currentDistributionYearSeq !== null &&
          distributionYear < currentDistributionYearSeq
        ) {
          return true;
        } else {
          return false;
        }
      }
      return true;
    });
  };
  const distributionListSeq = renderOptionList(
    filteredDistributionListSeq,
    "name",
    "id",
    defaultOption
  );
  useEffect(() => {
    if (
      dataSourceById?.referenceLogic === 0 ||
      dataSourceById?.referenceLogic === 1
    ) {
      setIsDistributionSeq(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataSourceById]);
  useEffect(() => {
    if (distributionData !== undefined) {
      setFilteredDistributionList(getFilterDistributionList(distributionData));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [distributionData, dataSourceById]);

  useEffect(() => {
    if (distributionWithSequence !== undefined) {
      setFilteredDistributionListSeq(
        getFilterDistributionSeqList(distributionWithSequence)
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [distributionWithSequence, dataSourceById]);

  let [distributionOptionList, setDistributionOptionList] = useState([
    {
      label: t("global.globalActions.optionDefault"),
      value: "",
    },
  ]);

  useEffect(() => {
    if (dataSourceById) {
      let distributionOptionList = isDistributionSeq
        ? distributionListSeq
        : distributionList;
      setDistributionOptionList(distributionOptionList);
      setValue("distribution", "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataSourceById, setValue, isDistributionSeq]);
  useEffect(() => {
    if(!isDirty){
      setValue("distribution", dataSourceById?.sourceDistributionId);

    }
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [distributionOptionList]);
  function handleFutureReferencingLogicChange(value: any) {
    setValue("distribution", "");
    if (value === "1" || value === "0") {
      setIsDistributionSeq(true);
    } else {
      setIsDistributionSeq(false);
    }
  }
  useEffect(() => {
    if (dataSourceById !== undefined) {
      setValue("manualDataSource", dataSourceById?.sourceManualDataSourceId);
      setValue(
        "entitleMentSet",
        dataSourceById?.isEntitlement === true ? "0" : "1"
      );
      reset(getValues());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataSourceById]);

  useEffect(() => {
    if (
     !isDirty &&
      calculationStepList.length > 1
    ) {
      setValue("calculationStep", dataSourceById?.sourceCalculationStepId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [calculationStep, dataSourceById]);

  useEffect(() => {
    if (
      distributionId !== "" &&
      distributionId !== undefined &&
      distributionId !== dataSourceById?.sourceDistributionId
    ) {
      setValue("calculationStep", "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [distributionId]);
  useEffect(() => {
    if (
      getDataSource === "1" &&
      (entitleMentSet === undefined || entitleMentSet === null)
    ) {
      setValue("entitleMentSet", "1");
    }
    if (getDataSource !== undefined && getDataSource !== "1") {
      setIsDistributionSeq(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDataSource]);

  if (
    isViewApiLoading ||
    isManualSourceLoading ||
    isDistributionLoading ||
    distributionWithSequenceLoading
  )
    return <MotifProgressLoader show variant="default" />;

  const cancelBtnApproveHandler = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
    setIsVisible(false);
    setIsVisibleCancel(false);
    setShowMessage({ ...showMessage, show: false, type: "error" });
    // setIsEdit(false);
  };

  const cancelBtnRejectHandler = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
    setIsVisibleCancel(false);
    setShowMessage({ ...showMessage, show: false, type: "error" });
  };

  return (
    <>
      <MotifModal
        onClose={() => {
          if (isDirty) {
            setIsVisibleCancel(true);
          } else {
            setIsVisible(false);
            setIsVisibleCancel(false);
            setShowMessage({ ...showMessage, show: false, type: "error" });
          }
        }}
        size="xl"
        show={isVisible}
        focusTrapOptions={{
          tabbableOptions: {
            displayCheck: "none",
          },
        }}
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="formModalWrapper">
            <MotifModalHeader>
              <span className="discard_heading">
                {t(
                  "pages.distributions.distributionStepsTab.dataSourceTab.dataSourceEditTitle"
                )}
              </span>
            </MotifModalHeader>
            <MotifModalBody>
              <div className="formModal">
                <div className="motif-row mar-t-20">
                  <div className="motif-col-md-5">
                    <ControlSelect
                      //@ts-ignore
                      name={"dataSource"}
                      //@ts-ignore
                      control={control}
                      required={true}
                      showLabel={true}
                      readonly={true}
                      disabled={resolvedStatus}
                      label={
                        "pages.distributions.distributionStepsTab.dataSourceTab.formLabels.dataSource"
                      }
                      //@ts-ignore
                      placeholder={"placeholder"}
                      options={[
                        {
                          label: t(
                            "pages.distributions.distributionStepsTab.dataSourceTab.dataSourceOptions.label1"
                          ),
                          value: "",
                        },
                        {
                          label: t(
                            "pages.distributions.distributionStepsTab.dataSourceTab.dataSourceOptions.label2"
                          ),
                          value: "0",
                        },
                        {
                          label: t(
                            "pages.distributions.distributionStepsTab.dataSourceTab.dataSourceOptions.label3"
                          ),
                          value: "1",
                        },
                        {
                          label: t(
                            "pages.distributions.distributionStepsTab.dataSourceTab.dataSourceOptions.label4"
                          ),
                          value: "2",
                        },
                      ]}
                    />
                  </div>
                </div>
                <div className="motif-row mar-t-20">
                  <div className="motif-col-md-5">
                    <ControlInputBoxNumber
                      // name={"weightingFactor"}
                      // // @ts-ignore
                      // control={control}
                      // required={true}
                      // isTextArea={false}
                      // label={"pages.distributions.distributionStepsTab.dataSourceTab.formLabels.weightingFactor"}
                      // showLabel={true}
                      // //@ts-ignore
                      // setValue={setValue}
                      // isNumber={true}
                      // maxLength={getValues("weightingFactor")?.toString().includes(".") ? 9 : 10}
                      // isAmount={true}
                      // onChangeAmount={onChangeAmount}
                      // validate={isNumeric}
                      name={"weightingFactor"}
                      // @ts-ignore
                      control={control}
                      required={true}
                      isTextArea={false}
                      label={
                        "pages.distributions.distributionStepsTab.dataSourceTab.formLabels.weightingFactor"
                      }
                      showLabel={true}
                      // setValue={setValue}
                      isNumber={true}
                      digitAfterDecimal={8}
                      isAmount={true}
                      onChangeAmount={() => {}}
                      validate={isNumeric}
                      readonly={resolvedStatus}
                    />
                  </div>
                </div>
                {getDataSource === "1" && (
                  <>
                    <div className="motif-row mar-t-20">
                      <div className="motif-col-md-5">
                        <FutureReferencingLogic
                          control={control}
                          setValue={setValue}
                          getValues={getValues}
                          selectedId={
                            dataSourceById &&
                            "" + dataSourceById?.referenceLogic
                          }
                          handleChange={handleFutureReferencingLogicChange}
                          disabled={resolvedStatus}
                        />
                        {errors["futureReferencingLogic"] &&
                          errors["futureReferencingLogic"].type ===
                            "required" && (
                            <MotifErrorMessage>
                              {t(
                                "pages.distributions.distributionStepsTab.dataSourceTab.validationMessages.futureReferencingLogicReq",
                                { fieldNames: errorsShow }
                              )}
                            </MotifErrorMessage>
                          )}
                      </div>
                    </div>
                    <div className="motif-row mar-t-20">
                      <div className="motif-col-md-5">
                        <ControlSelect
                          // @ts-ignore
                          name={"distribution"}
                          //@ts-ignore
                          control={control}
                          required={true}
                          showLabel={true}
                          readonly={true}
                          label={
                            "pages.distributions.distributionStepsTab.dataSourceTab.formLabels.distribution"
                          }
                          //@ts-ignore
                          placeholder={"placeholder"}
                          options={distributionOptionList}
                          disabled={resolvedStatus}
                        />
                      </div>
                      {isDistributionSequenceFetching && (
                        <MotifProgressLoader
                          className="align-self-center mar-t-20"
                          variant="circular"
                          size="xs"
                        ></MotifProgressLoader>
                      )}
                    </div>
                    <div className="motif-row mar-t-20">
                      <div className="motif-col-md-5">
                        <ControlSelect
                          // @ts-ignore
                          name={"calculationStep"}
                          //@ts-ignore
                          control={control}
                          required={true}
                          showLabel={true}
                          readonly={true}
                          filter={true}
                          disabled={stepCaluclationFetching || resolvedStatus}
                          label={
                            "pages.distributions.distributionStepsTab.dataSourceTab.formLabels.calculationStep"
                          }
                          //@ts-ignore
                          placeholder={"placeholder"}
                          options={calculationStepList}
                        />
                      </div>
                      {stepCaluclationFetching && (
                        <MotifProgressLoader
                          className="align-self-center mar-t-20"
                          variant="circular"
                          size="xs"
                        ></MotifProgressLoader>
                      )}
                    </div>
                    <div className="motif-row mar-t-20">
                      <div className="motif-col-md-5">
                        <ControlSelect
                          //@ts-ignore
                          name={"entitleMentSet"}
                          //@ts-ignore
                          control={control}
                          required={true}
                          showLabel={true}
                          readonly={true}
                          disabled={resolvedStatus}
                          label={
                            "pages.distributions.distributionStepsTab.dataSourceTab.formLabels.entitlement"
                          }
                          //@ts-ignore
                          placeholder={"placeholder"}
                          options={[
                            {
                              label: t(
                                "pages.distributions.distributionStepsTab.dataSourceTab.entitlementOptions.label1"
                              ),
                              value: "",
                            },
                            {
                              label: t(
                                "pages.distributions.distributionStepsTab.dataSourceTab.entitlementOptions.label2"
                              ),
                              value: "0",
                            },
                            {
                              label: t(
                                "pages.distributions.distributionStepsTab.dataSourceTab.entitlementOptions.label3"
                              ),
                              value: "1",
                            },
                          ]}
                        />
                        {errors["entitleMentSet"] &&
                          errors["entitleMentSet"].type === "required" && (
                            <MotifErrorMessage>
                              {t(
                                "pages.distributions.distributionStepsTab.dataSourceTab.validationMessages.entitlementReq",
                                { fieldNames: errorsShow }
                              )}
                            </MotifErrorMessage>
                          )}
                      </div>
                    </div>
                  </>
                )}

                {getDataSource === "2" && (
                  <div className="motif-row mar-t-20">
                    <div className="motif-col-md-5">
                      <ControlSelect
                        // @ts-ignore
                        name={"manualDataSource"}
                        //@ts-ignore
                        control={control}
                        required={true}
                        showLabel={true}
                        readonly={true}
                        label={
                          "pages.distributions.distributionStepsTab.dataSourceTab.formLabels.manualDataSource"
                        }
                        //@ts-ignore
                        placeholder={"placeholder"}
                        options={manualDataSourceList}
                        disabled={resolvedStatus}
                      />
                    </div>
                  </div>
                )}
                <div className="motif-row mar-t-20">
                  <div className="motif-col-md-5">
                    {/*@ts-ignore*/}
                    <ControlCheckBox
                      name={"filterApplicableClasses"}
                      control={control}
                      // @ts-ignore
                      showLabel={true}
                      label={t(
                        "pages.distributions.distributionStepsTab.dataSourceTab.formLabels.applicableClass"
                      )}
                      setValue={setValue}
                      getValues={getValues}
                      isFrenchSelected={isFrenchSelected}
                      setIsFrenchSelected={setIsFrenchSelected}
                      disabled={resolvedStatus}
                    />
                  </div>
                </div>
              </div>
              <MotifErrorMessage>
                {showMessage.show && showMessage.message}
                {errorList.length > 0 &&
                  t(
                    "pages.distributions.distributionStepsTab.dataSourceTab.validationMessages.mainMessage",
                    { fieldNames: errorsShow }
                  )}
              </MotifErrorMessage>
            </MotifModalBody>
            <MotifModalFooter>
              <div className="button-container-add">
                <Button
                  variant={SAVE_BUTTON_VARIANT}
                  label={t("global.globalActions.save")}
                  disabled={isLoading || resolvedStatus}
                  loading={isLoading}
                />
                <Button
                  label={t("global.globalActions.cancel")}
                  type="button"
                  variant={CANCEL_BUTTON_VARIANT}
                  className="cancelBtn"
                  onClickHandler={() => {
                    if (isDirty) {
                      setIsVisibleCancel(true);
                    } else {
                      setIsVisible(false);
                      setShowMessage({
                        ...showMessage,
                        show: false,
                        type: "error",
                      });
                      setFormData(null);
                    }
                  }}
                />
              </div>
            </MotifModalFooter>
          </div>
        </form>
      </MotifModal>
      <ConfirmationModal
        isVisible={isVisibleCancel}
        setIsVisible={setIsVisibleCancel}
        cancelBtnApproveHandler={cancelBtnApproveHandler}
        cancelBtnRejectHandler={cancelBtnRejectHandler}
      />
    </>
  );
}
